exports.list = {
    path: '/dokumen',
    name: 'dokumen', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/dokumen/List.vue"),
}
exports.show = {
    path: '/dokumen/show/:kode',
    name: 'dokumen_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/dokumen/Show.vue"),
}